// Shared channel-identity helpers for the analysis view's "Channels" pickers.
//
// A channel option's `source` is 'primary' for the primary driver, or the
// numeric compare-driver slot (0/1/2) — matching the `s2-${slot}-` series-key
// convention already used by SpeedTrace/GTrace/ChannelTrace. The compound
// `key` (`${source}::${name}`) keeps identically-named channels from two
// different sessions/loggers from colliding in selection state.

export const CHANNEL_EXCLUDE = new Set(['time', 'gps latitude', 'gps longitude', 'latitude', 'longitude']);

export function channelsFromSession(session, source) {
  if (!session?.channels) return [];
  return session.channels
    .map((name, i) => ({ name, unit: session.units?.[i] || '' }))
    .filter(ch => !CHANNEL_EXCLUDE.has(ch.name.toLowerCase()))
    .map(ch => ({ ...ch, source, key: `${source}::${ch.name}` }));
}

// Plain names persisted before driver-tagging shipped mean 'primary'.
export function parseChannelKey(key) {
  const i = key.indexOf('::');
  if (i === -1) return { source: 'primary', name: key };
  const rawSource = key.slice(0, i);
  const source = rawSource === 'primary' ? 'primary' : Number(rawSource);
  return { source, name: key.slice(i + 2) };
}
